import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import classnames from "classnames";
import jwtDecode from "jwt-decode";
import * as urls from "constants/AppConstants";
import { getConfigEmail } from "actions";
import LoadingScreen from "components/uis/loadingscreen/LoadingScreen";
import "./Settings.scss";
import { debounce } from "lodash";

class OauthVerify extends Component {
  state = {
    type: "",
    text: "",
    isLoading: true
  };

  componentDidMount() {
    this.props.getConfigEmail();
    const array = this.props.location.search.substring(1).split("&");
    const codeArray = {};
    array.forEach(e => {
      codeArray[e.split("=")[0]] = e.split("=")[1];
    });
    const { code } = codeArray;
    const source = codeArray.state;
    if (code) {
      let postdata;
      let postdata2;
      switch (source) {
        case "gmail":
          postdata = {
            client_id: process.env.GMAIL_CLIENT_ID,
            client_secret: process.env.GMAIL_CLIENT_SECRET,
            redirect_uri: `${window.location.origin.toString()}${
              urls.REDIRECT_URL
            }`,
            grant_type: "authorization_code",
            code
          };
          postdata2 = {
            smtp_host: "smtp.gmail.com",
            smtp_port: 587,
            smtp_encrypt_type: "TLS"
          };
          break;
      }

      axios
        .post("/rest-api/oauth_token/", postdata)
        .then(res => {
          const resData = JSON.parse(res.data);
          (postdata2.oauth2_refresh_token = resData.refresh_token),
            (postdata2.smtp_provider = source);
          if (resData.id_token) {
            const userInfo = jwtDecode(resData.id_token);
            postdata2.smtp_id = userInfo.email;
            if (
              postdata2.smtp_id &&
              (resData.refresh_token ||
                postdata2.smtp_id ==
                  this.props.configEmail.CompanyEmail.smtp_id)
            ) {
              return this.handleSuccess(postdata2);
            }
          }
          this.handleError(
            "We couldn't connect to this account, please make sure the email address is correct and then try again later."
          );
        })
        .catch(err => {
          this.handleError(
            "We couldn't connect to this account, please make sure the email address is correct and then try again later."
          );
        });
    } else {
      this.handleError(
        "There was an error connecting with the email service, please try later."
      );
    }
  }

  onClose = debounce(() => {
    window.close();
  }, 120);

  handleSuccess = data => {
    this.setState({
      type: "success",
      text: `Your email has been connected successfully!`,
      isLoading: false
    });
    axios
      .put(
        `${urls.COMPANY_EMAIL_CONFIG}${this.props.configEmail.CompanyEmail.id}/`,
        data
      )
      .then(res => {
        window.opener.location.reload();
        this.onClose();
      })
      .catch(err => {
        this.handleError(
          "We could not configure this email at this time, please try again later."
        );
      });
  };

  handleError = error => {
    this.setState({
      type: "error",
      text: error,
      isLoading: false
    });
  };

  render() {
    return (
      <div
        className={classnames(
          "alert",
          { "alert-success": this.state.type === "success" },
          { "alert-danger": this.state.type === "error" }
        )}
        style={{ margin: "20vh 10vw" }}
      >
        <LoadingScreen isLoading={this.state.isLoading === true} />
        {this.state.text}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth?.user,
    configEmail: state.configEmail
  };
};

export default connect(mapStateToProps, { getConfigEmail })(OauthVerify);
